<template>
  <div class="navbar" :class="roles[0] | navbarClassFilter">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <div class="float-left p-3">{{ roles[0] + ':' + name }}</div>

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img :src="logo" class="user-avatar" />
          <div class="float-right">
            <div class="user-name">{{ name }}</div>
            <i class="el-icon-caret-bottom" />
          </div>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item> Home </el-dropdown-item>
          </router-link>

          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">Log Out</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import logo from '@/assets/images/logo.svg';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    logo,
  },
  data() {
    return {
      logo,
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'name', 'roles']),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    async logout() {
      // console.log(`[Navbar.vue] [logout] fullPath: ${this.$route.fullPath}`);
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
  filters: {
    navbarClassFilter(val) {
      if (val === undefined) return;
      // console.log(
      // `[Navbar.vue] [navbarClassFilter] val: ${JSON.stringify(val)}`
      // );
      const circuit = val.match(/巡補/g);
      if (circuit) return 'circuit';
    },
  },
};
</script>

<style lang="scss">
.user-dropdown {
  margin-top: 0;
  top: 50px;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .user-name {
        display: flex;
        align-content: center;
        align-items: center;
        height: 40px;
        margin-left: 6px;
        line-height: 40px;
        cursor: pointer;
        text-align: right;
        float: left;
      }

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          top: 0;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          float: right;
          text-align: right;
          position: relative;
          top: 12px;
        }
      }
    }
  }
}

.circuit {
  background: #a6c39b;
}
</style>
